// Converted to lazy loading
const storesIndex = () => import('@/pages/stores/stores/index.vue')
const storesForm = () => import('@/pages/stores/stores/form.vue')
const storesShow = () => import('@/pages/stores/stores/show.vue')

const productsIndex = () => import('@/pages/stores/products/index.vue')
const productsForm = () => import('@/pages/stores/products/form.vue')
const productsShow = () => import('@/pages/stores/products/show.vue')

const materialsIndex = () => import('@/pages/stores/materials/index.vue')
const materialsForm = () => import('@/pages/stores/materials/form.vue')
const materialsShow = () => import('@/pages/stores/materials/show.vue')

const storesDepositsIndex = () => import('@/pages/stores/storesDeposits/index.vue')
const storesDepositsForm = () => import('@/pages/stores/storesDeposits/form.vue')
const storesDepositsShow = () => import('@/pages/stores/storesDeposits/show.vue')

const storesOrdersIndex = () => import('@/pages/stores/storeOrders/index.vue')
const storesOrdersForm = () => import('@/pages/stores/storeOrders/form.vue')
const storesOrdersShow = () => import('@/pages/stores/storeOrders/show.vue')

const storesWithdrawalsIndex = () => import('@/pages/stores/storesWithdrawals/index.vue')
const storesWithdrawalsForm = () => import('@/pages/stores/storesWithdrawals/form.vue')
const storesWithdrawalsShow = () => import('@/pages/stores/storesWithdrawals/show.vue')

const productsInsurancesIndex = () => import('@/pages/stores/productsInsurances/index.vue')
const productsInsurancesForm = () => import('@/pages/stores/productsInsurances/form.vue')
const productsInsurancesShow = () => import('@/pages/stores/productsInsurances/show.vue')

const storesTransfersIndex = () => import('@/pages/stores/storesTransfers/index.vue')
const storesTransfersForm = () => import('@/pages/stores/storesTransfers/form.vue')
const storesTransfersShow = () => import('@/pages/stores/storesTransfers/show.vue')

const storesSettlementsIndex = () => import('@/pages/stores/storesSettlements/index.vue')
const storesSettlementsForm = () => import('@/pages/stores/storesSettlements/form.vue')
const storesSettlementsShow = () => import('@/pages/stores/storesSettlements/show.vue')
const productBarcode = () => import('@/pages/stores/productsBarcode/barcode.vue')
const PriceListForm = () => import('@/pages/stores/priceLists/form.vue')
const PriceListIndex = () => import('@/pages/stores/priceLists/index.vue')

const routes = [
  {
    path: 'stores',
    name: 'stores',
    component: storesIndex
  },
  {
    path: 'stores/create',
    name: 'storesCreate',
    component: storesForm
  },
  {
    path: 'stores/:id/edit',
    name: 'storesEdit',
    component: storesForm
  },

  {
    path: 'stores/:id',
    name: 'storesShow',
    component: storesShow
  },

  //products routs
  {
    path: 'products',
    name: 'products',
    component: productsIndex
  },
  {
    path: 'products/create',
    name: 'productsCreate',
    component: productsForm
  },

  {
    path: 'products/:id/edit',
    name: 'productsEdit',
    component: productsForm
  },

  {
    path: 'products/:id',
    name: 'productsShow',
    component: productsShow
  },
  {
    path: 'priceLists',
    name: 'priceLists',
    component: PriceListIndex
  },
  {
    path: 'priceLists/create',
    name: 'priceListsCreate',
    component: PriceListForm
  },
  {
    path: 'priceLists/:id/edit',
    name: 'priceListsEdit',
    component: PriceListForm
  },
  {
    path: 'productsBarcode',
    name: 'productsBarcode',
    component: productBarcode
  },
  {
    path: 'productsBarcode/bill/:id',
    name: 'productsBarcodeBill',
    component: productBarcode
  },

  //materials routs
  {
    path: 'materials',
    name: 'materials',
    component: materialsIndex
  },
  {
    path: 'materials/create',
    name: 'materialsCreate',
    component: materialsForm
  },
  {
    path: 'materials/:id/edit',
    name: 'materialsEdit',
    component: materialsForm
  },

  {
    path: 'materials/:id',
    name: 'materialsShow',
    component: materialsShow
  },

  //storesDeposits routes
  {
    path: 'storesDeposits',
    name: 'storesDeposits',
    component: storesDepositsIndex
  },
  {
    path: 'storesDeposits/create',
    name: 'storesDepositsCreate',
    component: storesDepositsForm
  },
  {
    path: 'storesDeposits/:id/edit',
    name: 'storesDepositsEdit',
    component: storesDepositsForm
  },

  {
    path: 'storesDeposits/:id',
    name: 'storesDepositsShow',
    component: storesDepositsShow
  },
  //storesWithdrawals routes
  {
    path: 'storesWithdrawals',
    name: 'storesWithdrawalsIndex',
    component: storesWithdrawalsIndex
  },
  {
    path: 'storesWithdrawals/create',
    name: 'storesWithdrawalsCreate',
    component: storesWithdrawalsForm
  },
  {
    path: 'storesWithdrawals/:id/edit',
    name: 'storesWithdrawalsEdit',
    component: storesWithdrawalsForm
  },

  {
    path: 'storesWithdrawals/:id',
    name: 'storesWithdrawalsShow',
    component: storesWithdrawalsShow
  },
  {
    path: 'productsInsurances',
    name: 'productsInsurancesIndex',
    component: productsInsurancesIndex
  },
  {
    path: 'productsInsurances/create',
    name: 'productsInsurancesCreate',
    component: productsInsurancesForm
  },
  {
    path: 'productsInsurances/:id/edit',
    name: 'productsInsurancesEdit',
    component: productsInsurancesForm
  },

  {
    path: 'productsInsurancesShow/:id',
    name: 'productsInsurancesShow',
    component: productsInsurancesShow
  },
  //StoresOrders routes
  {
    path: 'storesOrders',
    name: 'storesOrders',
    component: storesOrdersIndex
  },
  {
    path: 'storesOrders/create',
    name: 'storesOrdersCreate',
    component: storesOrdersForm
  },
  {
    path: 'storesOrders/:id/edit',
    name: 'storesOrdersEdit',
    component: storesOrdersForm
  },

  {
    path: 'storesOrders/:id',
    name: 'storesOrdersShow',
    component: storesOrdersShow
  },
  //storesTransfers routes
  {
    path: 'storesTransfers',
    name: 'storesTransfers',
    component: storesTransfersIndex
  },
  {
    path: 'storesTransfers/create',
    name: 'storesTransfersCreate',
    component: storesTransfersForm
  },
  {
    path: 'storesTransfers/:id/edit',
    name: 'storesTransfersEdit',
    component: storesTransfersForm
  },
  {
    path: 'storesTransfers/:id',
    name: 'storesTransfersShow',
    component: storesTransfersShow
  },
  {
    path: 'storesSettlements',
    name: 'storesSettlements',
    component: storesSettlementsIndex
  },
  {
    path: 'storesSettlements/create',
    name: 'storesSettlementsCreate',
    component: storesSettlementsForm
  },
  {
    path: 'storesSettlements/:id/edit',
    name: 'storesSettlementsEdit',
    component: storesSettlementsForm
  },
  {
    path: 'storesSettlements/:id',
    name: 'storesSettlements',
    component: storesSettlementsShow
  },
  {
    path: 'barcode',
    name: 'barcode',
    component: productBarcode
  }
]

export default routes
